import {useSearchParams} from 'react-router-dom';
import DotsLoading from '../../components/dotsLoading';
import useGetLoadingTransactionSponsor from '../../services/hookService/sponsor/getTransactionLoadingSponsor/useGetLoadingTransactionSponsor';

const Receipt = () => {
  const [searchParams] = useSearchParams();
  useGetLoadingTransactionSponsor({
    guid: searchParams.get('guid') as string,
  });

  return (
    <div className="w-full h-full flex flex-col bg-white justify-center items-center">
      <DotsLoading />
    </div>
  );
};
export default Receipt;
